module.exports = __webpack_public_path__ + "img/image1.57fb3def.png";